import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useContext, useCallback } from "react";
import { UseTableElementContext } from "./Table.js";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toFeatureClass } from "../../utils/toFeatureClass.js";
import { toStateClass } from "../../utils/toStateClass.js";
const TableRow = memo(({ active, children, id, justification, onClick: onClickProp }) => {
  const useTableElement = useContext(UseTableElementContext);
  const className = classNames(
    useComponentClassName("table-row"),
    toEnumViewClass(justification),
    toFeatureClass("hover", !!onClickProp),
    toFeatureClass("press", !!onClickProp),
    toStateClass("active", active)
  );
  const onClick = useCallback(() => {
    if (id !== void 0) {
      onClickProp?.(id);
    }
  }, [id, onClickProp]);
  if (useTableElement) {
    return /* @__PURE__ */ jsx("tr", { onClick, className, children });
  }
  return /* @__PURE__ */ jsx("div", { onClick, className, children });
});
TableRow.displayName = "TableRow";
export {
  TableRow
};
//# sourceMappingURL=TableRow.js.map
